import AuthMiddleware from "@/middleware/auth"

const AllEMRInsurances = () =>
  import(
    /* webpackChunkName: "emr-insurances" */ "@/components/emrInsurances/AllEMRInsurances"
  )

const EMRInsurancesRouter = [
  {
    path: "/emr-insurances",
    name: "AllEMRInsurances",
    component: AllEMRInsurances,
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "EMR INSURANCES",
    },
  },
]

export { EMRInsurancesRouter }
